/* Typeahead: remove price element for products tagged "24hour_Y" */
(function () {
  const SEARCH_INPUT_SELECTOR = '.js--autosearch.info-bar__search__input';
  const CARD_SELECTOR  = 'li.omega__products';
  const PRICE_SELECTOR = '.omega__product-price';
  const REQUIRED_TAG   = '24hour_Y';

  // Cache product tags by normalized product URL
  const tagCache = new Map();

  function getProductUrlFromOnclick(li) {
    const onclick = li.getAttribute('onclick') || '';
    const m = onclick.match(/window\.location\.href\s*=\s*['"]([^'"]+)['"]/);
    return m ? m[1] : null;
  }
  function normalizeProductUrl(url) {
    if (!url || !url.startsWith('/')) return null;
    if (!url.startsWith('/products/')) return null; // ignore /pages/ etc.
    return url.replace(/[?#].*$/, '').replace(/\/+$/, '');
  }
  function extractHandle(prodUrl) {
    const parts = prodUrl.split('/').filter(Boolean); // ['products','<handle>',...]
    return parts[1] || null;
  }
  async function fetchTagsOnce(prodUrl) {
    const norm = normalizeProductUrl(prodUrl);
    if (!norm) return null;
    if (tagCache.has(norm)) return tagCache.get(norm);

    const handle = extractHandle(norm);
    if (!handle) { tagCache.set(norm, null); return null; }

    const endpoint = `${location.origin}/products/${handle}.js`;
    try {
      const res = await fetch(endpoint, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const tags = Array.isArray(data.tags)
        ? data.tags.map(String)
        : String(data.tags || '').split(',').map(s => s.trim()).filter(Boolean);
      tagCache.set(norm, tags);
      return tags;
    } catch {
      tagCache.set(norm, null);
      return null;
    }
  }
  function hasRequiredTag(tags) {
    return Array.isArray(tags) && tags.includes(REQUIRED_TAG);
  }
  function removePrice(li) {
    if (li.dataset.y24Removed === '1') return; // already processed
    const priceEl = li.querySelector(PRICE_SELECTOR);
    if (priceEl) {
      priceEl.remove();
      li.dataset.y24Removed = '1';
    }
  }

  let raf1 = null, raf2 = null;
  function cancelScheduled() {
    if (raf1 !== null) { cancelAnimationFrame(raf1); raf1 = null; }
    if (raf2 !== null) { cancelAnimationFrame(raf2); raf2 = null; }
  }
  function scheduleScan() {
    cancelScheduled();
    // wait for suggestions to render (double rAF)
    raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(async () => {
        raf1 = raf2 = null;
        const cards = Array.from(document.querySelectorAll(CARD_SELECTOR));
        for (const li of cards) {
          const url = normalizeProductUrl(getProductUrlFromOnclick(li));
          if (!url) continue; // skips /pages/ etc.

          const tags = tagCache.has(url) ? tagCache.get(url) : await fetchTagsOnce(url);
          if (hasRequiredTag(tags)) removePrice(li);
        }
      });
    });
  }

  function init() {
    const input = document.querySelector(SEARCH_INPUT_SELECTOR);
    if (!input) return;

    input.addEventListener('input', scheduleScan);

    // React when suggestion list changes (items added/removed)
    const mo = new MutationObserver(muts => {
      for (const m of muts) {
        if (m.addedNodes.length || m.removedNodes.length) { scheduleScan(); break; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();






